'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Accordion, { accordionClasses, } from '@enlighten/design-system/dist/Accordion';
import AccordionDetails from '@enlighten/design-system/dist/AccordionDetails';
import AccordionSummary, { accordionSummaryClasses, } from '@enlighten/design-system/dist/AccordionSummary';
import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import { useState } from 'react';
import * as ArrowComponent from '../../assets/images/arrow.svg';
import ImgQuestion1 from '../../assets/images/exchange/img-question-1.png';
import ImgQuestion2 from '../../assets/images/exchange/img-question-2.png';
import ImgQuestion3 from '../../assets/images/exchange/img-question-3.png';
const roleCards = [
    {
        image: ImgQuestion1,
        title: 'KPX 전력거래소',
        subtitle: '계통 안정 및 효율적 운영',
        description: '중개사업자를 통해 재생에너지의 발전량을 예측, 안정적인 계통 운영의 대가로 정산금 지급',
    },
    {
        image: ImgQuestion2,
        title: '엔라이튼',
        subtitle: '분산자원 관리 및 발전량 예측',
        description: '분산자원을 하나의 집합자원으로 하여 발전량을 예측하고, 예측에 대한 정산금을 받음',
    },
    {
        image: ImgQuestion3,
        title: '20MW 이하 소규모 발전 사업자',
        subtitle: '기존 수익 + 추가 수익 실현',
        description: '발전사업자는 기존 SMP + REC 수익 외에 중개사업자를 통해 정산금 추가 수익을 얻음',
    },
];
function RoleCard({ image, title, subtitle, description, }) {
    return (_jsxs(Stack, { sx: {
            bgcolor: 'white',
            border: '1px solid #EBEDEF',
            borderRadius: '20px',
            boxShadow: '0px 4px 10px 0px rgba(0,0,0,0.05)',
            padding: { xs: '28px 24px', md: '56px 48px' },
            gap: '32px',
            '@container (max-width: 1000px)': {
                padding: '28px 24px',
            },
        }, children: [_jsxs(Stack, { gap: "12px", children: [_jsx(Image, { src: image, alt: "", width: 32, height: 32 }), _jsx(Typography, { fontSize: { xs: 20, md: 24 }, fontWeight: 700, children: title })] }), _jsxs(Stack, { gap: "8px", children: [_jsx(Typography, { fontSize: { xs: 16, md: 18 }, fontWeight: 700, children: subtitle }), _jsx(Typography, { fontSize: { xs: 14, md: 16 }, sx: {
                            lineHeight: '26px',
                            mt: '8px',
                            wordBreak: 'keep-all',
                        }, children: description })] })] }));
}
const Arrow = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? ArrowComponent.default
    : ArrowComponent.ReactComponent;
export default function ExchangeSection4({ onClickLink, }) {
    const [accordionIndex, setAccordionIndex] = useState(0);
    const list = [
        {
            summary: '전력중개 제도가 무엇인가요?',
            details: (_jsxs(_Fragment, { children: ["\uC804\uB825\uC911\uAC1C\uC0AC\uC5C5\uC790\uAC00 \uBC1C\uC804\uB7C9\uC744 \uC608\uCE21\uD558\uC5EC KPX\uC5D0 \uC81C\uCD9C\uD558\uC5EC \uB9DE\uCD9C \uACBD\uC6B0 \uD568\uAED8 \uCC38\uC5EC\uD55C \uC18C\uADDC\uBAA8 \uBC1C\uC804\uC0AC\uC5C5\uC790\uAC00 \uCD94\uAC00 \uC218\uC775\uC744 \uC5BB\uC744 \uC218 \uC788\uB294 \uC81C\uB3C4\uC785\uB2C8\uB2E4.", _jsx(Box, { sx: {
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
                            gap: '16px',
                            mt: 5,
                            containerType: 'inline-size',
                        }, children: roleCards.map((card) => (_jsx(RoleCard, { ...card }, card.title))) })] })),
        },
        {
            summary: '투자 비용이 발생하나요?',
            details: '태양광 발전소를 운영하고 계신 사업주라면 투자 비용은 일체 발생하지 않습니다.',
        },
        {
            summary: '제도 참여 신청은 어떻게 하나요?',
            details: '페이지 하단 신청하기 버튼 또는 고객센터로 직접 문의하시면 언제든 참여 신청 가능합니다.',
        },
        {
            summary: '정산금은 어떻게 산정되나요?',
            details: (_jsxs(Grid, { sx: (theme) => ({
                    lineHeight: 1.5,
                    a: {
                        color: theme.palette.primary.main,
                    },
                }), children: ["\uC815\uC0B0\uAE08\uC561 \uC0B0\uC815 \uBC29\uC2DD\uC740 \uC804\uB825\uAC70\uB798\uC18C \uD648\uD398\uC774\uC9C0(", _jsx(Button, { variant: "text", onClick: onClickLink, sx: {
                            fontSize: 18,
                            fontWeight: 400,
                            height: 27,
                            padding: 0,
                        }, children: "der.kmos.kr" }), ")\uC5D0\uC11C \uC2DC\uC7A5 \uC18C\uAC1C >\uBC1C\uC804\uB7C9 \uC608\uCE21 \uC81C\uB3C4\uB97C \uD1B5\uD574 \uD655\uC778 \uAC00\uB2A5\uD558\uC2DC\uBA70, \uAE30\uD0C0 \uC138\uBD80\uC0AC\uD56D\uC740 \uACC4\uC57D\uC11C\uB97C \uD1B5\uD574 \uD655\uC778 \uAC00\uB2A5\uD558\uC2ED\uB2C8\uB2E4."] })),
        },
        {
            summary: '정산금은 언제 입금되나요?',
            details: '정산금은 세금계산서 발행 이후, 20일 이내 지급됩니다.',
        },
    ];
    return (_jsxs(Grid, { container: true, direction: "column", alignItems: "center", maxWidth: 1440, padding: { xs: '60px 24px', md: '100px 24px 140px' }, marginX: "auto", children: [_jsx(Typography, { fontSize: { xs: 24, md: 40 }, fontWeight: 700, lineHeight: 1.35, textAlign: "center", marginBottom: 5, children: '모두가 궁금해 한\n그 질문에 답합니다.' }), _jsx(Grid, { container: true, direction: "column", borderColor: "grey.300", sx: {
                    borderTopWidth: 1,
                    borderTopStyle: 'solid',
                }, children: list.map(({ summary, details }, i) => (_jsxs(Accordion, { expanded: accordionIndex === i, onChange: () => {
                        setAccordionIndex((index) => {
                            if (index == null || index !== i) {
                                return i;
                            }
                            return undefined;
                        });
                    }, sx: (theme) => ({
                        borderBottom: i === list.length - 1
                            ? `1px solid ${theme.palette.grey['300']}`
                            : 'none',
                        borderRadius: 0,
                        boxShadow: 'none',
                        transition: 'background-color 0.3s ease',
                        [`&.${accordionClasses.expanded}`]: {
                            bgcolor: 'grey.100',
                            margin: 0,
                        },
                    }), children: [_jsx(AccordionSummary, { expandIcon: _jsx(Arrow, { width: 24, height: 24, viewBox: "6 12 12 24", fill: "#AFB4B9" }), sx: {
                                fontSize: { xs: 15, md: 20 },
                                lineHeight: 1.5,
                                letterSpacing: '-.05em',
                                color: 'common.black',
                                height: { xs: 48, md: 88 },
                                padding: { xs: '20px 24px', md: '20px 50px' },
                                svg: {
                                    transform: 'rotate(180deg)',
                                },
                                [`&.${accordionSummaryClasses.expanded}`]: {
                                    fontWeight: 700,
                                    minHeight: { xs: 48, md: 88 },
                                },
                                [`.${accordionSummaryClasses.content}`]: {
                                    margin: { xs: 0, md: '12px 0' },
                                },
                            }, children: summary }), _jsx(AccordionDetails, { sx: {
                                fontSize: { xs: 16, md: 18 },
                                lineHeight: 1.5,
                                letterSpacing: '-.05em',
                                whiteSpace: 'pre-line',
                                marginBottom: '1em',
                                paddingX: { xs: '24px', md: '50px' },
                                paddingY: '20px',
                            }, children: details })] }, i))) })] }));
}
